export default "__VITE_ASSET__B66ASEs2__"